var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.386,
    height: 72.298,
    viewBox: "0 0 79.386 72.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9_Copy",
    "data-name": "Group 9 Copy",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8_Copy_2",
    "data-name": "Group 8 Copy 2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_10",
    "data-name": "Oval Copy 10",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_11",
    "data-name": "Oval Copy 11",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(14.6 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_12",
    "data-name": "Oval Copy 12",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(29.199 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_13",
    "data-name": "Oval Copy 13",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(43.799 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_14",
    "data-name": "Oval Copy 14",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(58.398 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_15",
    "data-name": "Oval Copy 15",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(72.998 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8_Copy_3",
    "data-name": "Group 8 Copy 3",
    transform: "translate(0 11.341)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_10-2",
    "data-name": "Oval Copy 10",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_11-2",
    "data-name": "Oval Copy 11",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(14.6 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_12-2",
    "data-name": "Oval Copy 12",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(29.199 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_13-2",
    "data-name": "Oval Copy 13",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(43.799 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_14-2",
    "data-name": "Oval Copy 14",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(58.398 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_15-2",
    "data-name": "Oval Copy 15",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(72.998 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8_Copy_4",
    "data-name": "Group 8 Copy 4",
    transform: "translate(0 21.973)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_10-3",
    "data-name": "Oval Copy 10",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_11-3",
    "data-name": "Oval Copy 11",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(14.6 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_12-3",
    "data-name": "Oval Copy 12",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(29.199 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_13-3",
    "data-name": "Oval Copy 13",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(43.799 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_14-3",
    "data-name": "Oval Copy 14",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(58.398 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_15-3",
    "data-name": "Oval Copy 15",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(72.998 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8_Copy_5",
    "data-name": "Group 8 Copy 5",
    transform: "translate(0 32.605)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_10-4",
    "data-name": "Oval Copy 10",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_11-4",
    "data-name": "Oval Copy 11",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(14.6 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_12-4",
    "data-name": "Oval Copy 12",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(29.199 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_13-4",
    "data-name": "Oval Copy 13",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(43.799 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_14-4",
    "data-name": "Oval Copy 14",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(58.398 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_15-4",
    "data-name": "Oval Copy 15",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(72.998 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8_Copy_6",
    "data-name": "Group 8 Copy 6",
    transform: "translate(0 43.945)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_10-5",
    "data-name": "Oval Copy 10",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_11-5",
    "data-name": "Oval Copy 11",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(14.6 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_12-5",
    "data-name": "Oval Copy 12",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(29.199 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_13-5",
    "data-name": "Oval Copy 13",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(43.799 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_14-5",
    "data-name": "Oval Copy 14",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(58.398 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_15-5",
    "data-name": "Oval Copy 15",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(72.998 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8_Copy_7",
    "data-name": "Group 8 Copy 7",
    transform: "translate(0 54.577)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_10-6",
    "data-name": "Oval Copy 10",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_11-6",
    "data-name": "Oval Copy 11",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(14.6 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_12-6",
    "data-name": "Oval Copy 12",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(29.199 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_13-6",
    "data-name": "Oval Copy 13",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(43.799 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_14-6",
    "data-name": "Oval Copy 14",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(58.398 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_15-6",
    "data-name": "Oval Copy 15",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(72.998 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8_Copy_8",
    "data-name": "Group 8 Copy 8",
    transform: "translate(0 65.918)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_10-7",
    "data-name": "Oval Copy 10",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_11-7",
    "data-name": "Oval Copy 11",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(14.6 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_12-7",
    "data-name": "Oval Copy 12",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(29.199 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_13-7",
    "data-name": "Oval Copy 13",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(43.799 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_14-7",
    "data-name": "Oval Copy 14",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(58.398 0)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_Copy_15-7",
    "data-name": "Oval Copy 15",
    cx: 3.194,
    cy: 3.19,
    rx: 3.194,
    ry: 3.19,
    transform: "translate(72.998 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.ddd232e5.svg";
export { ForwardRef as ReactComponent };